import React, {useRef} from "react"
import Icon from "../Icon/Icon"
import {useToggle, useClickAway} from "react-use"
import classNames from "classnames"
import {useTimezone, TimezoneOption} from "../../services/timezone"

export default function NavbarTimezoneDropdown() {
	const ref = useRef(null)
	const [isDropdownActive, toggleDropdown] = useToggle(false)
	useClickAway(ref, () => toggleDropdown(false))
	const {timezone, setTimezone, getTimezoneLabel, getTimezoneDisplayText} = useTimezone()

	const dropdownClassname = classNames("navbar-timezone-dropdown dropdown is-centered", isDropdownActive && "is-active")

	const timezoneOptions: TimezoneOption[] = ["browser", "UTC", "EST", "CST", "PST"]

	const handleTimezoneSelect = (tz: TimezoneOption) => {
		setTimezone(tz)
		toggleDropdown(false)
	}

	return (
		<div className={dropdownClassname} ref={ref}>
			<div className="navbar-timezone-dropdown-trigger" onClick={() => toggleDropdown()}>
				<Icon icon={"globe-1--maps-navigation"} />
				<span className="navbar-timezone-dropdown-trigger-text">{`  ${getTimezoneDisplayText(timezone)}  `}</span>
				<span className="navbar-timezone-dropdown-trigger-arrow">
					<Icon icon={"interface-arrows-button-down--interface-essential"} size={10} />
				</span>
			</div>
			<div className="dropdown-menu">
				<div className="dropdown-content">
					<ul className="navbar-timezone-dropdown-content-links">
						{timezoneOptions.map((tz) => (
							<li key={tz}>
								<a className="has-icon" onClick={() => handleTimezoneSelect(tz)}>
									<span className="menu-item-label">{getTimezoneLabel(tz)}</span>
									<span className="icon checkmark">
										{timezone === tz && <Icon size={10} icon="interface-validation-check--interface-essential" />}
									</span>
								</a>
							</li>
						))}
					</ul>
				</div>
			</div>
		</div>
	)
}
